class Default {
	beforeEnter(data) {
		console.log('beforeEnter');

		// scroll to top instantly
		window.scrollTo(0, 0);
	}

	afterEnter(data) {
		console.log('afterEnter');
		const id = $(data.next.container).data('id');
		window._header.handleActiveClass(id);
		window._mobileNavigation.close();
	}

	afterLeave(data) {
		console.log('afterLeave');
	}
}

export default Default;
